export default __webpack_public_path__ + "static/media/edit-onclick.6d505cac.svg";